<template>
  <AccordionSection
    :id="item?.fields.id ?? `section-${item.sys.id}`"
    :color-mode="item.fields.theme"
    :open-multiple-items="item.fields.openMultipleAccordionItems"
    :item-heading-level="level"
    v-bind="
      ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'headline'
      })
    "
  >
    <Headline v-if="item.fields.headline" :item="item.fields.headline" />
    <MappedComponents
      v-if="props.item.fields.customContent"
      :items="props.item.fields.customContent"
    />
    <AccordionItem
      v-for="{ fields, sys } in item.fields.accordionItems"
      :key="sys.id"
      :is-open="fields.initiallyOpened"
    >
      <template #title>{{ fields.title }}</template>
      <MappedComponents :items="fields.contentSlot ?? []" />
    </AccordionItem>
  </AccordionSection>
</template>

<script setup lang="ts">
import {
  AccordionSection,
  AccordionItem
} from '@hypercodestudio/basler-components';
import Headline from './Headline.vue';
import { mapHeadlineLevel } from '~/utils/mapHeadlineLevel';
import type { IAccordionSection } from '~/lib/ContentfulService';
import { ContentfulLivePreview } from '@contentful/live-preview';

interface Props {
  item: IAccordionSection;
}

const props = defineProps<Props>();

const level = computed(() => mapHeadlineLevel(props.item.fields.headingMarkup));
</script>
